// -----------------------------------------------------------------------
// Import React and other resources
// -----------------------------------------------------------------------
import React from "react";
import { connect } from "react-redux";
import { TextInput, Text, Button, InlineAlert, toaster } from "evergreen-ui";
import {
  createMemberPin,
  getIndividualMemberDetails,
  getMemberDetails,
  togglePremiumFeatureFlag
} from "../../actions";
import { resourcesNotLoadedToast } from "../../utils";

// -----------------------------------------------------------------------
// SetPinDialogContent Component
// -----------------------------------------------------------------------
class SetPinDialogContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newPin: "",
      confirmPin: "",
      showPinMatchesMsg: false,
      showPinDoesNotMatchMsg: false,
      isNewPinInvalid: false,
      isConfirmPinInvalid: false
    };
  }

  // -----------------------------------------------------------------------
  // changePinInput()
  // -----------------------------------------------------------------------
  changePinInput = async (e, changeFor) => {
    e.persist();
    if (changeFor === "new-pin") {
      await this.setState({ newPin: e.target.value.toString().trim() });
      if (this.state.newPin.length > 0) {
        await this.setState({ isNewPinInvalid: false });
      }
    }
    if (changeFor === "confirm-pin") {
      await this.setState({ confirmPin: e.target.value.toString().trim() });
    }
    await this.checkPinMatches(e);
  };

  // -----------------------------------------------------------------------
  // checkPinMatches()
  // -----------------------------------------------------------------------
  checkPinMatches = async e => {
    e.persist();
    if (this.state.newPin.length > 0) {
      await this.setState({ isNewPinInvalid: false });
      if (this.state.confirmPin.length > 0) {
        if (this.state.confirmPin === this.state.newPin) {
          this.setState({
            showPinDoesNotMatchMsg: false,
            showPinMatchesMsg: true,
            isNewPinInvalid: false,
            isConfirmPinInvalid: false
          });
        } else {
          this.setState({
            showPinDoesNotMatchMsg: true,
            showPinMatchesMsg: false,
            isNewPinInvalid: false,
            isConfirmPinInvalid: true
          });
        }
      } else {
        this.setState({
          showPinDoesNotMatchMsg: false,
          showPinMatchesMsg: false,
          isNewPinInvalid: false,
          isConfirmPinInvalid: false
        });
      }
    } else if (
      this.state.confirmPin.length > 0 &&
      this.state.newPin.length <= 0
    ) {
      this.setState({
        showPinDoesNotMatchMsg: false,
        showPinMatchesMsg: false,
        isNewPinInvalid: true,
        isConfirmPinInvalid: false
      });
    } else if (this.state.confirmPin.length <= 0) {
      this.setState({
        showPinDoesNotMatchMsg: false,
        showPinMatchesMsg: false,
        isNewPinInvalid: false,
        isConfirmPinInvalid: false
      });
    }
  };

  // -----------------------------------------------------------------------
  // handleConfirmSetPin()
  // -----------------------------------------------------------------------
  handleConfirmSetPin = async e => {
    e.persist();
    if (
      this.state.newPin !== "" &&
      this.state.confirmPin !== "" &&
      !this.state.isNewPinInvalid &&
      !this.state.isConfirmPinInvalid &&
      !this.state.showPinDoesNotMatchMsg &&
      this.state.showPinMatchesMsg
    ) {
      this.setState({
        isNewPinInvalid: false,
        isConfirmPinInvalid: false
      });
      let reqBody = {
        clubId: this.props.clubId,
        mobile: this.props.mobile.toString(),
        newPin: this.state.newPin.toString()
      };
      await this.props.dispatch(createMemberPin(reqBody));
      if (this.props.createMemberPinToast) {
        if (this.props.createMemberPinToast.resourcesNotLoadedMessage) {
          resourcesNotLoadedToast();
        } else if (this.props.createMemberPinToast.httpErrorMessage) {
          toaster.danger(this.props.createMemberPinToast.httpErrorMessage, {
            id: "HTTP-ERROR-TOAST-1"
          });
        } else if (this.props.createMemberPinToast.requestStatus === -1) {
          toaster.notify("Sorry, you don't have permission to do that");
        } else if (this.props.createMemberPinToast.requestStatus === 1) {
          this.props.dispatch(
            getIndividualMemberDetails({
              clubId: this.props.clubId,
              page: 1,
              mobile: this.props.mobile
            })
          );
          this.props.dispatch(
            getMemberDetails({
              clubId: this.props.clubId,
              page: this.props.pageNumOnMembersPage
            })
          );
          if (this.props.individualMemberDetailsToast) {
            if (
              this.props.individualMemberDetailsToast.resourcesNotLoadedMessage
            ) {
              resourcesNotLoadedToast();
            } else if (
              this.props.individualMemberDetailsToast.httpErrorMessage
            ) {
              toaster.danger(
                this.props.individualMemberDetailsToast.httpErrorMessage,
                {
                  id: "HTTP-ERROR-TOAST-4"
                }
              );
            } else if (
              this.props.individualMemberDetailsToast.requestStatus === -1
            ) {
              toaster.notify("Sorry, you don't have permission to do that");
            } else if (
              this.props.individualMemberDetailsToast.requestStatus === 0
            ) {
              toaster.danger(this.props.individualMemberDetailsToast.message, {
                id: "USER-TOAST"
              });
            }
          }
          if (this.props.memberDetails) {
            if (this.props.memberDetails.resourcesNotLoadedMessage) {
              resourcesNotLoadedToast();
            } else if (this.props.memberDetails.httpErrorMessage) {
              toaster.danger(this.props.memberDetails.httpErrorMessage, {
                id: "HTTP-ERROR-TOAST-4"
              });
            } else if (this.props.memberDetails.requestStatus === -1) {
              toaster.notify("Sorry, you don't have permission to do that");
            } else if (this.props.memberDetails.requestStatus === 0) {
              toaster.danger(this.props.memberDetails.message, {
                id: "USER-TOAST"
              });
            }
          }
          await this.props.handleSetPinDialogVisibility("close");
          await toaster.success(this.props.createMemberPinToast.message);
        } else if (this.props.createMemberPinToast.requestStatus === 0) {
          toaster.danger(this.props.createMemberPinToast.message);
        }
      }
    } else {
      if (this.state.newPin === "") {
        await this.setState({
          isNewPinInvalid: true
        });
      }
      if (this.state.confirmPin === "") {
        await this.setState({
          isConfirmPinInvalid: true
        });
      }
    }
  };

  // -----------------------------------------------------------------------
  // render()
  // -----------------------------------------------------------------------
  render() {
    const {
      showPinMatchesMsg,
      showPinDoesNotMatchMsg,
      isNewPinInvalid,
      isConfirmPinInvalid
    } = this.state;
    const { handleSetPinDialogVisibility } = this.props;
    return (
      <React.Fragment>
        <div className="SPDC-A1-wrapper">
          <div className="SPDC-A1-body-container">
            <div className="SPDC-A1-col-container">
              <Text marginBottom={8} id="SPDC-A1-label">
                New Pin
              </Text>
              <TextInput
                type="password"
                width={280}
                height={32}
                placeholder="Enter PIN"
                isInvalid={isNewPinInvalid}
                onChange={e => this.changePinInput(e, "new-pin")}
                onBlur={e => this.checkPinMatches(e)}
              />
            </div>
            <div className="SPDC-A1-col-container SPDC-A1-last-col-container">
              <Text marginBottom={8} id="SPDC-A1-label">
                Confirm
              </Text>
              <TextInput
                type="password"
                width={280}
                height={32}
                placeholder="Re-enter PIN"
                isInvalid={isConfirmPinInvalid}
                onChange={e => this.changePinInput(e, "confirm-pin")}
                // onBlur={e => this.checkPinMatches(e)}
              />
              {showPinMatchesMsg && (
                <InlineAlert marginTop={8} intent="success">
                  <Text size={300} id="SPDC-A1-success-inline-alert">
                    Pin matches
                  </Text>
                </InlineAlert>
              )}
              {showPinDoesNotMatchMsg && (
                <InlineAlert marginTop={8} c intent="danger">
                  <Text size={300} id="SPDC-A1-danger-inline-alert">
                    Pin does not match
                  </Text>
                </InlineAlert>
              )}
            </div>
          </div>
          <div className="SPDC-A1-footer-container">
            <Button
              className="button"
              width={72}
              height={32}
              marginRight={12}
              onClick={() => handleSetPinDialogVisibility("close")}
            >
              Cancel
            </Button>
            <Button
              className="button"
              width={88}
              height={32}
              appearance="primary"
              intent="success"
              onClick={e => this.handleConfirmSetPin(e)}
            >
              Set PIN
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  createMemberPinToast,
  individualMemberDetailsToast,
  memberDetails
}) => ({
  createMemberPinToast,
  individualMemberDetailsToast,
  memberDetails
});

// -----------------------------------------------------------------------
// Export
// -----------------------------------------------------------------------
export default connect(mapStateToProps)(SetPinDialogContent);
